import React from "react";
import { ReactComponent as Contact } from "../../assets/contact.svg";
import { ReactComponent as Phone } from "../../assets/phone.svg";
import { ReactComponent as Place } from "../../assets/place.svg";
import { ReactComponent as Mail } from "../../assets/email.svg";
import { ReactComponent as Work } from "../../assets/work.svg";
import { ReactComponent as Copy } from "../../assets/copy.svg";
export interface ShowDataProps {
  label: string;
  value: string;
  primaryColor: string;
  canCopy?: boolean;
  iconId?: string;
  phonePrefix?: string;
  toast?: any;
  small?: boolean;
}

export const ShowData = (props: ShowDataProps) => {
  const getIcon = () => {
    switch (props.iconId) {
      case "contact":
        return (
          <Contact
            color={props.primaryColor}
            width={30}
            height={30}
            style={{ marginLeft: "-4px" }}
          />
        );
      case "phone":
        return (
          <Phone
            color={props.primaryColor}
            width={30}
            height={25}
            style={{ marginLeft: "-3px" }}
          />
        );
      case "place":
        return (
          <Place
            color={props.primaryColor}
            width={30}
            height={25}
            style={{ marginLeft: "-5px" }}
          />
        );
      case "email":
        return (
          <Mail
            color={props.primaryColor}
            width={"28px"}
            height={"28px"}
            style={{ marginLeft: "-3px" }}
          />
        );
      case "work":
        return (
          <Work
            color={props.primaryColor}
            width={30}
            height={25}
            style={{ marginLeft: "-3px" }}
          />
        );
      default:
        return "";
    }
  };

  const getTextOptions = () => {
    if (props.iconId === "email") {
      return (
        <a
          style={{ color: "inherit", textDecoration: "none" }}
          href={`mailto:${props.value}`}
        >
          {props.value}
        </a>
      );
    } else if (props.iconId === "phone") {
      if (props.phonePrefix) {
        return (
          <a
            style={{ color: "inherit", textDecoration: "none" }}
            href={`tel:${props.phonePrefix}${props.value}`}
          >
            {`${props.value}`}
          </a>
        );
      } else {
        return (
          <a
            style={{ color: "inherit", textDecoration: "none" }}
            href={`tel:${props.value}`}
          >
            {props.value}
          </a>
        );
      }
    } else {
      return props.value;
    }
  };

  const getMargin = () => {
    if (props.small) {
      if (props.iconId) {
        return "6px 0";
      } else {
        return "-5px 0 6px 0";
      }
    } else {
      if (props.iconId) {
        return "10px 0";
      } else {
        return "-8px 0 10px 0";
      }
    }
  };

  return (
    <div
      style={{
        width: "80%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "start",
        gap: "8px",
        alignSelf: "center",
        placeSelf: "center",
        margin: getMargin(),
      }}
    >
      {props.iconId ? (
        <div>{getIcon()}</div>
      ) : (
        <div style={{ width: "21px" }}></div>
      )}
      <p
        style={{
          margin: 0,
          color: props.primaryColor,
          fontSize: "15px",
          fontWeight: 600,
          textAlign: "start",
          textTransform: props.iconId === "email" ? "lowercase" : "uppercase",
        }}
      >
        {getTextOptions()}
      </p>
      {props.canCopy && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <Copy
            color={props.primaryColor}
            width={20}
            height={20}
            onClick={() => {
              navigator.clipboard.writeText(props.value);
              props.toast.success(`${props.label} copiado al portapapeles`, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }}
          />
          <p style={{ color: props.primaryColor, fontSize: "10px", margin: 0 }}>
            Copiar
          </p>
        </div>
      )}
    </div>
  );
};
